export default __webpack_public_path__ + "static/media/auto_barva-min.a2359099.png";